var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-row',{attrs:{"order":this.order},on:{"expand":function($event){_vm.expanded = !_vm.expanded}}}),(_vm.expanded)?_vm._l((_vm.items.slice(1)),function(order){return _c('table-row',{key:order.id,attrs:{"order":order,"items":_vm.items}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }